import { APARENCIA_ESTADO_INCIDENTE } from '@/constants/status.constants';
import { formatarInicioIncidente, formatarMomentoCurto } from '@/helpers/formatacao.helpers';
import type { IncidenteAtivo as IncidenteAtivoTipo } from '@/types/status.types';

type IncidenteAtivoProps = {
  incidente: IncidenteAtivoTipo;
};

export const IncidenteAtivo = ({ incidente }: IncidenteAtivoProps) => {
  const aparencia = APARENCIA_ESTADO_INCIDENTE[incidente.estado];

  return (
    <section className="cartao-status" style={{ borderLeft: '3px solid var(--warning)' }}>
      <div className="flex flex-wrap items-baseline gap-2.5">
        <h2 className="m-0 text-[15px] font-semibold tracking-[-0.01em]">{incidente.titulo}</h2>
        <span className="text-[12px] font-semibold" style={{ color: aparencia.cor }}>
          {aparencia.rotulo}
        </span>
        <div className="flex-1" />
        <span className="text-[12px] text-muted-foreground">
          início {formatarInicioIncidente(incidente.iniciado_em)}
        </span>
      </div>

      {incidente.resumo && (
        <p className="mt-2 mb-0 text-[14px] leading-[1.55] text-pretty text-muted-foreground">
          {incidente.resumo}
        </p>
      )}

      {incidente.atualizacoes.length > 0 && (
        <ol className="mt-[18px] flex list-none flex-col p-0">
          {incidente.atualizacoes.map((atualizacao) => {
            const aparenciaAtualizacao = APARENCIA_ESTADO_INCIDENTE[atualizacao.estado];

            return (
              <li
                key={`${atualizacao.em}-${atualizacao.estado}`}
                className="flex flex-wrap gap-x-4 gap-y-1 border-t border-border py-3"
              >
                <div className="w-[104px] flex-none">
                  <div
                    className="text-[12px] font-bold tracking-[0.05em] uppercase"
                    style={{ color: aparenciaAtualizacao.cor }}
                  >
                    {aparenciaAtualizacao.rotulo}
                  </div>
                  <div className="mt-[3px] text-[12px] text-muted-foreground">
                    <time dateTime={atualizacao.em}>{formatarMomentoCurto(atualizacao.em)}</time>
                  </div>
                </div>
                <p className="m-0 min-w-[200px] flex-1 text-[14px] leading-[1.55] text-pretty">
                  {atualizacao.texto}
                </p>
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
};
